import { mapGetters } from 'vuex';
export default {
    
    computed: {
        
        filteredList: function () {    
            
                    
            let mixinWord = this.$store.getters['search/data']('word')
            let mixinListdata = this.$store.getters['search/data']('list')
            let mixinSearchtags = this.$store.getters['search/data']('tags')
            if(mixinListdata == null || !this.items.length || !Array.isArray(this.items)) {
                return this.items
            }           
            let mixinField = mixinListdata.variable 
            let mixinList = this.items
            let c = mixinListdata.constraint
            if(c.field != "") {                
                mixinList=this.items.filter((e) => {return e[c.field] == c.value})
            } 
            if(Array.isArray(mixinSearchtags) && mixinSearchtags.length) {
                
                mixinList=mixinList.filter((item)=>{
                    return item.tags.some((tag)=>{
                        return mixinSearchtags.includes(tag.id)
                    })
                })
            }
            if(mixinWord != "" && mixinWord != null)                           
            {                       
                return mixinList.filter((item) => {
                    let field=item[mixinField]                        
                    return field.toString().toLowerCase().match(mixinWord.toString().toLowerCase());
                }) 
            }
            return mixinList
        },
        
       
    }
}
